<upp-select uppDataid="language"
    [disabled]="IsDisabled"
    [value]="value"
    (Changed)="OnSelectChanged($event)"
>
    <upp-select-item>
        <ion-item>
            <ion-icon class="flag-box" slot="start" [ngClass]="LanguageFlag(value)"></ion-icon>
            <ion-label>
                {{ tr('@language_' + value) }}<br/>
                <span class="small" *ngIf="title">{{ title }}</span>
            </ion-label>
        </ion-item>
    </upp-select-item>
    <upp-select-list>
        <upp-select-option *ngFor="let language of Languages; trackBy: LanguageTrack" [uppDataid]="'language-' + language"
            [value]="language"
        >
            <ion-item>
                <ion-icon class="flag-box" slot="start" [ngClass]="LanguageFlag(language)"></ion-icon>
                <ion-label>{{ tr('@language_' + language) }}</ion-label>
            </ion-item>
        </upp-select-option>
    </upp-select-list>
</upp-select>
